import { render, staticRenderFns } from "./ItemMappingView.vue?vue&type=template&id=27e16ea0"
import script from "./ItemMappingView.vue?vue&type=script&lang=js"
export * from "./ItemMappingView.vue?vue&type=script&lang=js"
import style0 from "./ItemMappingView.vue?vue&type=style&index=0&id=27e16ea0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports